<template>
	<div class="action-checklist">
		<Loading v-if="checking" text="Sicherheitsprüfung..."/>
		<template v-else>
			<div class="tag-sections mt-4">
				<section v-if="withMyData">
					<h2>Meine Daten</h2>
					<CustomerData
						@change="loadAuth"
					/>
				</section>
				<section>
					<h2 v-if="withSecurityTitle">Sicherheit</h2>
					<Item
						:type="phone ? ('Telefonnummer (' + phone.formatted + ')') : 'Telefonnummer'"
						:status="security.mobilePhoneConfirmed ? 'done' : 'open'"
						:confirmation-date="security.mobilePhoneDate"
						@confirmNow="confirmNow = 'mobilePhone'"
					/>
					<Item
						:type="email ? ('E-Mail Adresse (' + email + ')') : 'E-Mail Adresse'"
						:status="security.emailConfirmed ? 'done' : 'open'"
						:confirmation-date="security.emailDate"
						class="mt-2"
						@confirmNow="confirmNow = 'email'"
					/>
					<!--<Item
						v-if="withIdentification"
						type="Ausweis"
						:status="getStatusByIdentificationStatus(security.identificationStatus)"
						:confirmation-date="security.identificationDate"
						class="mt-2"
						@confirmNow="confirmNow = 'identification'"
					/>-->
					<!--<Item
						v-if="withSearchPermission"
						type="Suchberechtigung"
						:status="security.searchPermissionConfirmed ? 'done' : 'open'"
						:confirmation-date="security.searchPermissionDate"
						class="mt-2"
						:with-confirm-now="false"
					/>-->
				</section>
				<section>
					<h2>Passwort ändern</h2>
					<ChangePassword/>
				</section>
			</div>
		</template>
		<UploadPopUp
			v-if="confirmNowIdentification"
			:meta="meta"
			@ok="onIdentificationChange"
			@asyncFinish="onIdentificationChange"
			@hidden="confirmNow = undefined"
		/>
		<ResendPopUp
			v-if="confirmNowEmailOrMobilePhone"
			:type="confirmNow"
			:resend-function="resendResendFunction"
			:change-function="resendChangeFunction"
			:phone="phone"
			@success="onConfirmEmailOrMobilePhoneSuccess"
			@hidden="confirmNow = undefined"
		/>
	</div>
</template>

<script>
import Item from "./Item";
import Loading from "@/vue/common/Loading";
import UploadPopUp from "@/vue/legitimation/identification/UploadPopUp";
import ResendPopUp from "@/vue/legitimation/ResendPopUp";
import {APPROVED, FINISHED, NEW} from "@/helper/legitimation/identification/Status";
import * as Toast from "@/helper/layout/Toast";
import flatten from "@/helper/error/Errors";
import ChangePassword from "@/vue/auth/password/Change";
import FormGroup from "@/vue/common/form/Group.vue";
import CustomerData from "@/vue/customer-area/CustomerData";
import {mapActions} from "vuex";

const CONFIRM_NOW_IDENTIFICATION = 'identification';
const CONFIRM_NOW_MOBILE_PHONE = 'mobilePhone';
const CONFIRM_NOW_EMAIL = 'email';

export default {

	components: {
		CustomerData,
		FormGroup,
		ChangePassword,
		Loading,
		Item,
		UploadPopUp,
		ResendPopUp,
	},

	props: {
		meta: {
			type: Object,
			required: true,
		},
		getSecurity: {
			type: Function,
			required: true,
		},
		changeIdentification: {
			type: Function,
			required: true,
		},
		resendResendFunction: {
			type: Function,
			required: true,
		},
		resendChangeFunction: {
			type: Function,
			required: true,
		},
		withIdentification: {
			type: Boolean,
			required: false,
			default: false
		},
		withSearchPermission: {
			type: Boolean,
			required: false,
			default: false
		},
		email: {
			type: String,
			required: false,
		},
		phone: {
			type: Object,
			required: false,
		},
		withMyData: {
			type: Boolean,
			required: false,
			default: true
		},
		withSecurityTitle: {
			type: Boolean,
			required: false,
			default: true
		},
	},

	mounted ()
	{
		this.check();
	},

	data ()
	{
		return {
			checking: true,
			security: null,
			confirmNow: undefined,
		};
	},

	computed: {
		confirmNowIdentification ()
		{
			return this.confirmNow === CONFIRM_NOW_IDENTIFICATION;
		},
		confirmNowEmailOrMobilePhone ()
		{
			return this.confirmNow === CONFIRM_NOW_MOBILE_PHONE
				|| this.confirmNow === CONFIRM_NOW_EMAIL;
		}
	},

	methods: {
		...mapActions('auth', {
			loadAuth: 'load'
		}),
		getStatusByIdentificationStatus (identificationStatus)
		{
			if (identificationStatus === NEW)
			{
				return 'open';
			}

			if (identificationStatus === FINISHED)
			{
				return 'questionable';
			}

			if (identificationStatus === APPROVED)
			{
				return 'done';
			}

			return 'open';
		},
		async check ()
		{
			this.checking = true;

			this.security = await this.getSecurity();

			this.checking = false;
		},
		async onIdentificationChange (identification)
		{
			try
			{
				await this.changeIdentification(identification);

				this.confirmNow = undefined;

				this.check();
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}
		},
		onConfirmEmailOrMobilePhoneSuccess ()
		{
			this.confirmNow = undefined;

			this.check();
		}
	}
}
</script>
